// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"1a6497e8","290":"401528c0","563":"a4187172","612":"3c920786","722":"3fb6bff9","758":"0e7343ac"}[chunkId] + ".chunk.js";
};